import { makeStyles } from '@seekube-tech/ui';

export default makeStyles((theme) => ({
  icon: {
    color: theme.palette.warning[500],
  },
}));
